export interface Toast {
  readonly id: string;
  readonly isExpanded: boolean;
  readonly type?: TOAST_TYPE;
  readonly message: string;
  readonly details?: string;
}

export enum TOAST_TYPE {
  DEFAULT = 'DEFAULT',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
